<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('aube-coin.forthing.history.title-label') }}</h3>
        </div>

        <div v-if="(! transactions)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class="container center-items text-center">
            <div v-if="(transactions)">
                <div class="container center-items m-0 p-0 mt-4">
                    <table class="table table-striped forthing-table">
                        <thead>
                            <tr class="bg-primary">
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.forthing.history.date-label') }}
                                </th>
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.forthing.history.volume-label') }}
                                </th>
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.forthing.history.paid-label') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="transaction in transactions" v-bind:key="transaction.id">
                                <td class="text-left">
                                    {{ transaction.created_at | moment('YYYY/MM/DD') }} (SGT)
                                </td>
                                <td class="text-left">
                                    {{ transaction.amount | round }}
                                </td>
                                <td class="text-center text-success">
                                    <div v-if="transaction.status === 'claimed'">
                                        <div v-if="transaction.claim_type === 'AUTO'">
                                            <i class="fa fa-check-circle fa-lg aube_stake_check_color"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ページネーション -->
            <div class="container center-items text-center m-0 p-0 mt-5">
                <paginate v-bind:pagination="pagination" v-on:change-page="fetch(true)"></paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from './../../components/Paginate';
    import Forthing2Service from './../../services/Forthing2Service';

    export default {
        name: 'TokenBalances',

        components: {
            Paginate,
        },

        data() {
            // transactions: = [{
            //     id: number,
            //     amount: string, // "0.294001230717928885"
            //     period_start: stirng, // "2025-10-01"
            //     period_end: string, // "2025-10-01"
            //     status: string, // "confirmed"
            //     claim_type: string | null, // "AUTO" | "MANUAL" | null
            //     created_at: string // "2025-10-01T06:58:33+08:00"
            // }]
            return {
                transactions: [],
                pagination: {
                    total_pages: 0,
                    current_page: 1,
                    per_page: 20,
                    total: 0,
                },
            }
        },

        mounted() {
            this.fetch();
        },

        created() {
        },

        methods: {
            async fetch(scrollToTop = false) {
                // Forthing2 APIのパラメータ形式に対応
                const params = {
                    page: this.pagination.current_page,
                    per_page: this.pagination.per_page,  // size → per_page に変更
                };

                // Forthing2 API を呼び出し
                let [ transactions ] = await Promise.all([
                    Forthing2Service.getForthingTransactions(params),
                ]);

                // Forthing2 API のレスポンス構造に対応
                // { data: [], meta: { pagination: {...} } }
                this.transactions = [];
                if (transactions.data && transactions.data.data) {
                    this.transactions = transactions.data.data;
                } else if (Array.isArray(transactions.data)) {
                    for (let i in transactions.data) {
                        if (transactions.data.hasOwnProperty(i) && i !== 'meta') {
                            this.transactions.push(transactions.data[i]);
                        }
                    }
                }

                // ページネーション情報を更新
                if (transactions.data && transactions.data.meta && transactions.data.meta.pagination) {
                    this.pagination = transactions.data.meta.pagination;
                }

                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
            },
        }
    }
</script>

<style scoped>
    .balanceBlock {
        display: flex;
        justify-content: space-between;
    }
    .forthing-table {
        border-collapse: separate;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        overflow: hidden;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .aube_user_wallet_check_color {
        color: #450080;
    }
    .aube_stake_check_color {
        color: #00ad69;
    }
    .check_color_position {
        text-align: left;
    }
</style>
